import React, { useState } from "react";
import { BookOpen, X, Download } from "lucide-react";

// Tlačidlo + modálne okno na prelistovanie PDF priamo na stránke.
const PdfViewer = ({ url, fileName, label = "Prelistovať program (PDF)" }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 bg-campaign-cream text-campaign-ink font-display uppercase text-sm sm:text-base px-5 py-4 border-2 border-campaign-ink shadow-brutal hover-lift"
      >
        <BookOpen size={20} /> {label}
      </button>

      {open && (
        <div
          className="fixed inset-0 z-[70] bg-campaign-ink/90 flex items-center justify-center p-3 sm:p-6"
          onClick={() => setOpen(false)}
        >
          <div
            className="relative w-full max-w-5xl h-[88vh] flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-2">
              <span className="font-display uppercase text-campaign-cream text-sm sm:text-base">
                Volebný program – prehliadač
              </span>
              <div className="flex items-center gap-3">
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  download={fileName}
                  className="inline-flex items-center gap-1.5 bg-campaign-yellow text-campaign-ink font-bold uppercase text-xs px-3 py-2 border-2 border-campaign-ink"
                >
                  <Download size={16} /> Stiahnuť
                </a>
                <button
                  onClick={() => setOpen(false)}
                  className="inline-flex items-center gap-1 text-campaign-cream font-bold uppercase text-sm"
                >
                  <X size={22} /> Zavrieť
                </button>
              </div>
            </div>
            <iframe
              src={`${url}#view=FitH`}
              title="Volebný program PDF"
              className="w-full flex-1 border-4 border-campaign-yellow bg-white"
            />
            <p className="mt-2 text-campaign-cream/70 text-xs text-center">
              Ak sa PDF nezobrazí (najmä na mobile), použite tlačidlo „Stiahnuť" alebo HTML verziu programu.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default PdfViewer;
